export enum RfInterferenceSeverity {
	None = 'NONE',
	Critical = 'CRITICAL'
}
